import { ThreadEvents } from "../../../../types"
import If from "../../if"
import Tooltip from "../../tool-tip"

interface Props {
  events: ThreadEvents
}

const EventsTooltip = ({ events }: Props) => {
  const dashClickedCount = events.filter(
    e => e.type === "dashboard_link_clicked"
  ).length

  const hasImmediateCall = events.some(event => event.type === "immediate_call")
  const hasScheduledCall = events.some(event => event.type === "scheduled_call")
  const hasCallEvents = hasScheduledCall || hasImmediateCall

  return (
    <>
      <If
        condition={dashClickedCount > 0}
        then={
          <Tooltip
            toolTipNode={<span>🔥 {dashClickedCount}+</span>}
            text={
              <ul className="text-[10px]">
                <li>
                  <span className="inline-block mr-1 -rotate-90">🧲</span> Dash
                  link clicked {dashClickedCount}x
                </li>
              </ul>
            }
            placement="top"
          />
        }
      />
      <If
        condition={hasCallEvents}
        then={
          <Tooltip
            toolTipNode={<span>📞</span>}
            text={
              <ul className="text-[10px]">
                <If
                  condition={hasScheduledCall}
                  then={
                    <li>
                      <span className="inline-block mr-1">🗓️</span> Scheduled
                      call
                    </li>
                  }
                />
                <If
                  condition={hasImmediateCall}
                  then={
                    <li>
                      <span className="inline-block mr-1">☎</span> Immediate
                      Call
                    </li>
                  }
                />
              </ul>
            }
            placement="top"
          />
        }
      />
    </>
  )
}

export default EventsTooltip
